import React, { useRef, useState } from 'react';

// ── Vitrine Marketing Studio — façon Higgsfield ───────────────────
// Vidéos d'exemple générées avec le Studio, chacune accompagnée de son prompt.
// « Utiliser ce prompt » charge le prompt dans le composeur (via applyPreset,
// aucune génération automatique — l'utilisateur ajuste puis clique Générer).
//
// Les fichiers vivent dans public/videos/ ; preload="metadata" + lecture au
// survol pour ne pas télécharger ~20 Mo par vidéo au chargement de la page.

const SHOWCASE = [
  {
    src: '/videos/showcase-1.mp4',
    label: 'Spot produit cinématique',
    tag: 'Commercial',
    aspect: '9:16',
    prompt:
      'cinematic product commercial, hero product on dark premium background, dramatic studio lighting, slow orbital camera movement, floating light particles, high-end advertising style, 4k',
  },
  {
    src: '/videos/showcase-2.mp4',
    label: 'UGC lifestyle authentique',
    tag: 'UGC',
    aspect: '9:16',
    prompt:
      'authentic UGC style video, young person showing product to camera, natural daylight, handheld smartphone framing, genuine smile and reactions, casual home setting, native social media feel',
  },
  {
    src: '/videos/showcase-3.mp4',
    label: 'Révélation urbaine énergique',
    tag: 'TikTok',
    aspect: '9:16',
    prompt:
      'dynamic streetwear reveal, urban night scene with neon reflections, fast cuts and whip pans, energetic model walking towards camera, moody cinematic color grade, trending TikTok aesthetic',
  },
  {
    src: '/videos/showcase-4.mp4',
    label: 'Démo produit lumineuse',
    tag: 'Meta',
    aspect: '4:5',
    prompt:
      'clean product demonstration, bright softbox lighting, hands presenting the product on a minimal table, smooth close-up camera slide, pastel background, reassuring conversion-focused ad style',
  },
];

const ShowcaseCard = ({ item, onUse }) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const play = () => { videoRef.current?.play().catch(() => {}); setPlaying(true); };
  const pause = () => { videoRef.current?.pause(); setPlaying(false); };

  return (
    <div
      className="group relative w-60 md:w-64 flex-shrink-0 rounded-2xl overflow-hidden bg-[#0F0B2D] shadow-lg"
      onMouseEnter={play}
      onMouseLeave={pause}
    >
      <div className="relative h-40 md:h-44">
        <video
          ref={videoRef}
          src={item.src}
          preload="metadata"
          muted
          loop
          playsInline
          onClick={() => (playing ? pause() : play())}
          className="w-full h-full object-cover cursor-pointer"
        />
        {!playing && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span className="w-10 h-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white text-lg">▶</span>
          </div>
        )}
        <span className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-wide bg-fuchsia-600 text-white px-2 py-0.5 rounded-full">
          {item.tag}
        </span>
      </div>
      <div className="p-3">
        <p className="text-white text-xs font-bold mb-1.5">{item.label}</p>
        <p className="text-white/50 text-[10px] leading-relaxed font-mono line-clamp-3 mb-2.5" title={item.prompt}>
          {item.prompt}
        </p>
        <button
          onClick={() => onUse(item)}
          className="w-full text-xs font-semibold bg-white/10 hover:bg-fuchsia-600 text-white rounded-xl py-2 transition"
        >
          🎬 Utiliser ce prompt
        </button>
      </div>
    </div>
  );
};

const ShowcaseGallery = ({ onUse }) => (
  <div className="mb-5">
    <div className="flex items-center justify-between mb-2.5">
      <h3 className="text-xs font-bold text-[#221C51] uppercase tracking-wide">
        🎞️ Vitrine Marketing Studio — exemples générés & leurs prompts
      </h3>
      <span className="text-[10px] text-gray-400 hidden md:block">survolez pour lire · cliquez sur un prompt pour le réutiliser</span>
    </div>
    <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
      {SHOWCASE.map((item) => (
        <ShowcaseCard
          key={item.src}
          item={item}
          onUse={(it) => onUse({ prompt: it.prompt, aspect: it.aspect, capability: 'text2video', label: it.label })}
        />
      ))}
    </div>
  </div>
);

export default ShowcaseGallery;
